(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseBookingRateOptions',
	};

	var mr_ineligible_msg = 'The rate code you selected is not combinable with the Flex Membership Rewards promotion. If you wish to continue, your client will not receive any MR points for this booking. Press "Yes" to continue or "No" to cancel';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var $modal = $(".modal"),
			rate_code;

		$('.rate-option-code').click(function showRateOptionDetails(e) {
			e.preventDefault();

			rate_code = $(this).data("code");

			$modal.find('.modal-title').text('Rate Option Details');
			$modal.find('.modal-body').html('<span class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-2x fa-spin"></span> Retrieving rate option information...');
			$modal.modal('show');

			Adzuki.Ajax.get('/CruiseBooking/rateOptionRules/' + rate_code)
			.then(function populate(rules) {
				$modal.find('.modal-body').html(rules);
			});
		});

		$('.rate-options .clickable-row p:not(:first-child)').click(function rowClicked(e) {
			var $parent = $(this).parents('li');

			if ($parent.find("input").prop('checked') === true) {
				$parent.find("input").prop('checked', false).trigger('change');
			} else {
				$parent.find("input").prop('checked', true).trigger('change');
			}

			handleNumChecked($parent.find("input"));
		});

		// $('.rate-checkbox').change(function checkboxChecked(e) {
		// 	handleNumChecked($(this));
		// });

		$('.rate-checkbox')
			.on(
				'change',
				function checkboxChecked(e) {
					handleNumChecked($(this));
					handleMrIneligibleSelected($(this));
				}
			)
		;
	};

	function handleMrIneligibleSelected(checkbox)
	{
		var num_checked = 0;
		var mr_eligible;
		var rate_mr_eligible;
		var checked_item;

		$('.rate-option-checkboxes').each(function countChecked(i, elem) {
			if ($(elem).prop('checked') === true) {
				num_checked++;
			}
		});

		if (num_checked === 1) {
			checked_item     = $('.rate-checkbox:checked');
			mr_eligible      = checked_item.data('mr-eligible');
			rate_mr_eligible = checked_item.data('rate-mr-eligible');

			if (
				mr_eligible !== undefined
				&& rate_mr_eligible !== undefined
				&& parseInt(mr_eligible) === 1
				&& parseInt(rate_mr_eligible) === 0
			) {
				form.confirm_message       = mr_ineligible_msg;
				form.confirm_before_submit = true;
			} else {
				form.confirm_message       = '';
				form.confirm_before_submit = false;
			}
		} else {
			form.confirm_message       = '';
			form.confirm_before_submit = false;
		}
	}

	function handleNumChecked(checkbox) {
		var num_checked = 0;

		$('.rate-option-checkboxes').each(function countChecked() {
			if ($(this).prop('checked') === true) {
				num_checked++;
			}
		});

		if (num_checked > 1) {
			$('#rate-option-form .submit-button').html('Show Rate Option Comparison <i class="'+Adzuki.FaIcon.getIconStyle('arrow_right')+'"></i>');
		} else {
			$('#rate-option-form .submit-button').html('Retrieve Available Cabin Categories <i class="'+Adzuki.FaIcon.getIconStyle('arrow_right')+'"></i>');
		}
	}
}(jQuery, window.Adzuki || {}));
